module.exports = __webpack_public_path__ + "static/media/code.62754a97.svg";